module.exports = __webpack_public_path__ + "img/q-4-1.527647ed.png";